import React from "react"
import { Slot } from "@radix-ui/react-slot"

import { IKTRichText, TResolvedImage } from "@/types/kontent.types"
import { parseIframeUrl } from "@/lib/utils"
import { RichTextSync, Typography } from "@/components/ui/atoms"

interface INewsletterIframeProps {
  asChild?: boolean
  title: string
  description: IKTRichText
  image: TResolvedImage | undefined
  iframe: string
}

const NewsletterIframe = React.forwardRef<
  HTMLDivElement,
  INewsletterIframeProps
>(({ asChild = false, title, iframe, description, image, ...props }, ref) => {
  const Component = asChild ? Slot : "div"
  return (
    <Component
      className="newsletter-iframe bg-secondary-400 lg:flex"
      ref={ref}
      {...props}
    >
      {image && image.width && image.height ? (
        <div className="newsletter-iframe--img w-full lg:w-6/12">
          <div
            className="h-full min-h-[225px] bg-cover bg-center"
            style={{
              backgroundImage: `url(${image.src}?w=1560&h=1020&fm=webp&q=80)`,
            }}
          />
        </div>
      ) : null}
      <div className="lg:w-6/12">
        <div className="mx-auto px-5 py-10 sm:max-w-xl md:max-w-3xl lg:ml-0 lg:max-w-lg lg:px-0 lg:pl-9 xl:max-w-[40rem] xl:pl-11 2xl:max-w-screen-md 2xl:pl-14">
          <div className="pl-0">
            <Typography as="h2" variant="headingM" className="mb-6">
              {title}
            </Typography>
            <RichTextSync className="pb-5" body={description} />
            <iframe
              width="100%"
              height={parseIframeUrl(iframe).height}
              src={parseIframeUrl(iframe).url}
              title="Formulaire d'inscription à la newsletter"
            ></iframe>
          </div>
        </div>
      </div>
    </Component>
  )
})
NewsletterIframe.displayName = "NewsletterIframe"

export { NewsletterIframe, type INewsletterIframeProps }
